import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {OrganismeFormationModel} from '../../models/organisme-formation/OrganismeFormationModel';
import {UrlUtils} from '../../utils/url-utils';
import {Observable, of} from 'rxjs';
import {NotificationToastService} from '../notifications/notification-toast.service';
import { switchMap, tap } from 'rxjs/operators';
import {ToastSuccesModel} from '../../models/toasts/toast-succes.model';
import {UploadUtilService} from '../../common/photo-uploader/upload-util.service';
import {base64string, FileConversionsUtil} from '../../utils/file-conversions-util';
import {FileDownloaderService} from '../../common/file-downloader.service';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class OrganismeFormationService {

  constructor(
    private http: HttpClient,   
    private notificationService: NotificationToastService,     
    private uploadUtilService: UploadUtilService ,
    private fileDownloaderService: FileDownloaderService,
    private configService: ConfigService
  ) { }

  organismeFormationAction = UrlUtils.generateActionUrlFormatter(`${this.configService.config.urlApi}/api/e/OrganismeFormation`);

  enregistrerOrganismeFormation(organisme: OrganismeFormationModel): Observable<void> {
    return this.http
      .post<void>(this.organismeFormationAction('enregistrerParametres'), organisme)
      .pipe(tap(() => this.notificationService.push(new ToastSuccesModel('Modifications organisme de formation enregistrées'))));
  }

  getOrganismeFormation(idEntite: number): Observable<OrganismeFormationModel> {
    return this.http.get<OrganismeFormationModel>(this.organismeFormationAction('get', [idEntite]))
  }

  getAllOrganismesFormation(): Observable<OrganismeFormationModel[]> {
    return this.http.get<OrganismeFormationModel[]>(this.organismeFormationAction('getAll'));
  }

  televerserLogo(logo: File, idEntite: number): Observable<any> {
    return this.uploadUtilService.uploadFile(this.organismeFormationAction('setLogo'), {File: logo, IdEntite: idEntite})
      .pipe(
        tap(() => this.notificationService.push(new ToastSuccesModel(`Fichier téléversé avec succès`)))
      );
  }

  supprimerLogo(idEntite: number): Observable<void> {
    return this.http.delete<void>(`${this.organismeFormationAction('deleteLogo')}/${idEntite}`).pipe(tap(() => {
      this.notificationService.push(new ToastSuccesModel(`Logo supprimé avec succès`))
    }))
  }

  chargerLogoAsBase64(idEntite: number): Observable<base64string> {
    return this.fileDownloaderService.fetchFile(`${this.organismeFormationAction('getLogo')}/${idEntite}`, null)
      .pipe(switchMap((blob: Blob) => {
        if (blob.size == 0) {
          return of(null)
        } else {
          return FileConversionsUtil.imageBlobToBase64(blob);
        }
      }))
  }
}
